module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/ai28-b03f62fdd924abf9a8bdcb2d4006834c.jpg";